export const CLONE_TABLE_ROW_HEIGHT = 80;
